import { render, staticRenderFns } from "./Page-OrderOfService.vue?vue&type=template&id=a4c46258&"
import script from "./Page-OrderOfService.vue?vue&type=script&lang=js&"
export * from "./Page-OrderOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports